import { AlertsContext } from "contexts/alert";
import React, { useContext } from "react";
import { Button } from "superbid-ui";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ButtonsForm = ({ styles, handleClose }) => {
    const {
        data,
        type,
        setShow,
        handleRemoveWishListItemById,
    } = useContext(AlertsContext);
    return (
        <div className={styles.button}>
            {
                type === 'edit' && (
                    <div className={styles.button_delete}>
                        <Button
                            className={styles.button_delete}
                            label="Excluir"
                            icon="MdDeleteOutline"
                            onClick={() => {
                                handleRemoveWishListItemById(data._id, data)
                                setShow(false);
                            }}
                        />
                    </div>
                )
            }
            <div
                className={styles.button_cancel}
                onClick={() => handleClose(false)}
                hidden={type === "edit"}
            >
                Voltar
            </div>
            <Button
                disableBtn={false}
                label={type === "edit" ? "Salvar alerta" : "Criar alerta"}
                icon={"MdOutlineBookmarkAdded"}
                template={"orange"}
                size={"large"}
            />{" "}
        </div>
    );
};

export const ActionButtons = React.memo(ButtonsForm);
